"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogId = void 0;
var react_1 = require("react");
var STORAGE_KEY = 'stremio_catalog_preferences';
var EVENT_NAME = 'stremio-catalog-preferences-changed';
var DEFAULT_PREFERENCES = {
    heroSectionEnabled: true,
    catalogPreferences: {},
    catalogOrder: [],
};
var getStoredPreferences = function () {
    try {
        var stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored) {
            var parsed = JSON.parse(stored);
            return __assign(__assign(__assign({}, DEFAULT_PREFERENCES), parsed), { catalogPreferences: __assign(__assign({}, DEFAULT_PREFERENCES.catalogPreferences), parsed.catalogPreferences) });
        }
    }
    catch (error) {
        console.error('Failed to load catalog preferences:', error);
    }
    return DEFAULT_PREFERENCES;
};
var savePreferences = function (preferences) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    }
    catch (error) {
        console.error('Failed to save catalog preferences:', error);
    }
    window.dispatchEvent(new Event(EVENT_NAME));
};
var getCatalogId = function (catalog) {
    var _a, _b, _c;
    if ((_a = catalog === null || catalog === void 0 ? void 0 : catalog.deepLinks) === null || _a === void 0 ? void 0 : _a.discover) {
        return catalog.deepLinks.discover;
    }
    if (((_c = (_b = catalog === null || catalog === void 0 ? void 0 : catalog.addon) === null || _b === void 0 ? void 0 : _b.manifest) === null || _c === void 0 ? void 0 : _c.id) && (catalog === null || catalog === void 0 ? void 0 : catalog.id) && (catalog === null || catalog === void 0 ? void 0 : catalog.type)) {
        return "".concat(catalog.addon.manifest.id, "_").concat(catalog.id, "_").concat(catalog.type);
    }
    if ((catalog === null || catalog === void 0 ? void 0 : catalog.name) && (catalog === null || catalog === void 0 ? void 0 : catalog.type)) {
        return "".concat(catalog.name, "_").concat(catalog.type);
    }
    return null;
};
exports.getCatalogId = getCatalogId;
var useCatalogPreferences = function () {
    var _a = (0, react_1.useState)(function () { return getStoredPreferences(); }), preferences = _a[0], setPreferences = _a[1];
    (0, react_1.useEffect)(function () {
        var handleStorageChange = function () {
            setPreferences(getStoredPreferences());
        };
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener(EVENT_NAME, handleStorageChange);
        return function () {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener(EVENT_NAME, handleStorageChange);
        };
    }, []);
    var updatePreferences = (0, react_1.useCallback)(function (updater) {
        setPreferences(function (prev) {
            var updated = updater(prev);
            savePreferences(updated);
            return updated;
        });
    }, []);
    var getHeroSectionEnabled = (0, react_1.useCallback)(function () {
        return preferences.heroSectionEnabled;
    }, [preferences.heroSectionEnabled]);
    var setHeroSectionEnabled = (0, react_1.useCallback)(function (enabled) {
        updatePreferences(function (prev) { return (__assign(__assign({}, prev), { heroSectionEnabled: enabled })); });
    }, [updatePreferences]);
    var getCatalogPreference = (0, react_1.useCallback)(function (catalog) {
        var catalogId = (0, exports.getCatalogId)(catalog);
        if (!catalogId)
            return null;
        return preferences.catalogPreferences[catalogId] || {
            enabled: true,
            order: -1,
            showInHero: undefined,
        };
    }, [preferences.catalogPreferences]);
    var setCatalogPreference = (0, react_1.useCallback)(function (catalog, preference) {
        var catalogId = (0, exports.getCatalogId)(catalog);
        if (!catalogId)
            return;
        updatePreferences(function (prev) {
            var _a;
            var current = prev.catalogPreferences[catalogId] || {
                enabled: true,
                order: -1,
                showInHero: true,
            };
            return __assign(__assign({}, prev), { catalogPreferences: __assign(__assign({}, prev.catalogPreferences), (_a = {}, _a[catalogId] = __assign(__assign({}, current), preference), _a)) });
        });
    }, [updatePreferences]);
    var getCatalogOrder = (0, react_1.useCallback)(function () {
        return preferences.catalogOrder;
    }, [preferences.catalogOrder]);
    var setCatalogOrder = (0, react_1.useCallback)(function (order) {
        updatePreferences(function (prev) { return (__assign(__assign({}, prev), { catalogOrder: order })); });
    }, [updatePreferences]);
    var isCatalogEnabled = (0, react_1.useCallback)(function (catalog) {
        var pref = getCatalogPreference(catalog);
        return pref ? pref.enabled : true;
    }, [getCatalogPreference]);
    var shouldShowInHero = (0, react_1.useCallback)(function (catalog, index) {
        var _a;
        if (index === void 0) { index = -1; }
        var pref = getCatalogPreference(catalog);
        return (_a = pref === null || pref === void 0 ? void 0 : pref.showInHero) !== null && _a !== void 0 ? _a : (index === 0);
    }, [getCatalogPreference]);
    return {
        preferences: preferences,
        getHeroSectionEnabled: getHeroSectionEnabled,
        setHeroSectionEnabled: setHeroSectionEnabled,
        getCatalogPreference: getCatalogPreference,
        setCatalogPreference: setCatalogPreference,
        getCatalogOrder: getCatalogOrder,
        setCatalogOrder: setCatalogOrder,
        isCatalogEnabled: isCatalogEnabled,
        shouldShowInHero: shouldShowInHero,
    };
};
exports.default = useCatalogPreferences;
